// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

import EmailSenderConfig from '../../components/admin/EmailSenderConfig'

/** Admin/management-portal outbound sender email (platform-level From identity). */
export default function PlatformEmailConfig() {
  return (
    <div style={{ padding: 24, maxWidth: '100%', margin: '0 auto' }}>
      <h1 style={{ fontSize: 22, margin: '0 0 4px' }}>Management email</h1>
      <p style={{ fontSize: 13, color: 'var(--color-text-mute)', margin: '0 0 8px' }}>
        The sender identity for mail the Owl Consultations management portal sends — platform-admin
        invitations, password resets, and system notifications.
      </p>
      <EmailSenderConfig
        title="Admin portal sender email"
        description="The From identity used for management-portal mail."
        scope={{ kind: 'platform' }}
      />
    </div>
  )
}
